module.exports = __webpack_public_path__ + "enterprise-application-integration.37PmHe6N.svg";